/** Firefox + WebKit: hide native steppers on `type="number"` inputs. */
export const hideNumberInputSpinnersClassName =
  '[-moz-appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none';
